import React, { Component } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import StyleTile from "./pages/StyleTile";
import Login from "./pages/Login";
import Register from "./pages/Register";
import PasswordResetRequest from "./pages/PasswordResetRequest";
import PasswordResetID from "./pages/PasswordResetID";
import Demo from "./pages/Demo";
import SizingForm from "./pages/SizingForm";
import Settings from "./pages/Settings";
import Dashboard from "./pages/Dashboard";
import AuthService from '../utils/AuthService';
import ManageBoats from './pages/ManageBoats';
import CreateEditBoat from './pages/CreateEditBoat';
import ManageUsers from './pages/ManageUsers';
import Report from './pages/Report';
import SizingFormStatus from './pages/SizingFormStatus';
import SizingFormCreated from './pages/SizingFormCreated';
import SizingFormConfigured from './pages/SizingFormConfigured';
import SizingFormApproved from './pages/SizingFormApproved';
import SizingFormPublished from './pages/SizingFormPublished';
import Stats from './pages/Stats';

var Auth = new AuthService();

// Auth logic with routes from this example:
// https://reacttraining.com/react-router/web/example/auth-workflow
class App extends Component {
	render() {
		return (
			<Switch>
				<Route path="/demo" component={Demo} />
				<Route path='/login' component={Login} />
				<Route path='/register' component={Register} />
				<Route path='/password-reset/:reset_id' component={PasswordResetID} />
				<Route path='/password-reset/' component={PasswordResetRequest} />
				<PrivateRoute exact path="/sizing-form" component={SizingForm} />
				<PrivateRoute exact path="/sizing-form/created" component={SizingFormCreated} />
				<PrivateRoute exact path="/sizing-form/configured" component={SizingFormConfigured} />
				<PrivateRoute exact path="/sizing-form/approved" component={SizingFormApproved} />
				<PrivateRoute exact path="/sizing-form/published" component={SizingFormPublished} />
				<PrivateRoute exact path="/sizing-form/published/:report_id" component={SizingFormPublished} />
				<PrivateRoute path="/sizing-form/status/:sizing_form_status" component={SizingFormStatus} />
				<PrivateRoute path="/sizing-form/:sizing_form_id" component={SizingForm} />
				<PrivateRoute path="/manage-boats/:bmy_id" component={CreateEditBoat} />
				<PrivateRoute path="/manage-boats" component={ManageBoats} />
				<PrivateRoute path="/view-boats/:bmy_id" component={CreateEditBoat} />
				<PrivateRoute path="/view-boats" component={ManageBoats} />
				<PrivateRoute path="/create-boat" component={CreateEditBoat} />
				<PrivateRoute path="/manage-users" component={ManageUsers} />
				<PrivateRoute path="/report/:report_id" component={Report} />
				<PrivateRoute exact path="/stats" component={Stats} />
				<Route path="/settings" component={Settings} />
				<Route path="/styletile" component={StyleTile} />
				<PrivateRoute path="/" component={Dashboard} />
			</Switch>
		);
	}
}

export default App;

const PrivateRoute = ({ component: Component, ...rest }) => (
	<Route {...rest} render={props =>
			Auth.loggedIn() ? (
				renderMergedProps(Component, props, rest)
			) : (
				<Redirect
					to={{
						pathname: "/login",
						state: { from: props.location }
					}}
				/>
			)
		}
	/>
);

const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest);
  return (
    React.createElement(component, finalProps)
  );
};



// WEBPACK FOOTER //
// ./src/components/App.js